export const CONTACT: string = (import.meta as any).env?.VITE_CONTACT_EMAIL ?? 'info@soncnik.si';
